import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storesApi } from "../../api";
import { AllServices, IDetailServices } from "../types";


type IServices = {
    loading: boolean;
    error: string | null;
    detail: IDetailServices | null
    data: AllServices[] | null
}

const initialState: IServices = {
    loading: false,
    error: null,
    detail: null,
    data:null
};

export const fetchByServices = createAsyncThunk(
    'projects/fetchByServices',
    async (_, { rejectWithValue }) => {
        try {
        const res = await storesApi.getServices()
            return res.data.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Ошибка сервера');
        }
    })


export const fetchByDetailservices = createAsyncThunk<IDetailServices, number, { rejectValue: string }>(
    'services/fetchByDetailservices',
    async (id, { rejectWithValue }) => {
        try {
            const res = await storesApi.getDetailServices(id)
            return res.data;
         } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Ошибка сервера');
        }
    })



const servicesSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {},
    extraReducers: ({ addCase }) => {
        addCase(fetchByDetailservices.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        addCase(fetchByDetailservices.fulfilled, (state, action) => {
            state.detail = action.payload;
            state.loading = false;
        });
        addCase(fetchByDetailservices.rejected, (state) => {
            state.loading = false;
            state.error = 'Ошибка сервера!';
        });

        addCase(fetchByServices.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        addCase(fetchByServices.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        });
        addCase(fetchByServices.rejected, (state) => {
            state.loading = false;
            state.error = 'Ошибка сервера!';
        });
    },
})



export default servicesSlice.reducer





